import * as THREE from "three";
import Experience from "./Experience.js";

export default class Camera {
	constructor() {
		this.experience = new Experience();
		this.sizes = this.experience.sizes;
		this.scene = this.experience.scene;
		this.canvas = this.experience.canvas;

		this.setInstance(0, 0);

		this.instance.position.set(0, 0, 8);
	}

	setInstance(x) {
		this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100);
		this.instance.position.set(x, x, 8);
		this.scene.add(this.instance);
	}

	resize() {
		this.instance.aspect = this.sizes.width / this.sizes.height;
		this.instance.updateProjectionMatrix();
	}

	update() {
		const scrollY = this.experience.scroll.scrollY || 0;
		this.instance.position.x = scrollY;
	}
}
